<div
  class="flex flex-col items-center mx-auto overflow-y-auto w-full h-auto min-h-full
    bg-neutral-900 md:bg-transparent-dark backdrop-blur md:rounded-[10px] shadow p-8 md:p-16"
>
  <div class="space-y-4">
    <div class="flex flex-row items-center md:items-end justify-between">
      <p class="text-3xl leading-tight tracking-normal">
        Create account
      </p>
      <p class="text-xs leading-tight tracking-wide text-[#f8f8f8]">
        Step {{ signUpStep() }} of 2
      </p>
    </div>

    <p class="text-sm text-neutral-100 leading-tight tracking-wide">
      Already have an account? <a [routerLink]="['..', 'signin']">Login</a>
    </p>

    @if (errorMessage) {
      <div class="w-full bg-[#9730307f] h-10 border-l-2 border-l-error">
        <span class="text-xs min-h-full inline-flex items-center ml-3">{{ errorMessage }}</span>
      </div>
    }

    @switch (signUpStep()) {
      @case (1) {
        <nrc-sign-up-form-login (continueEvent)="handleLogin($event)" />
      }
      @case (2) {
        <nrc-sign-up-form-profile
          (backEvent)="handleProfileBack()"
          (doneEvent)="handleProfile($event)"
        />
      }
      @default {
        <div>Unable to display sign up form</div>
      }
    }
  </div>
</div>
